import Matrix from 'ml-matrix';
import { reimAbsolute, reimFFT, reimPhaseCorrection, xMultiply, } from 'ml-spectra-processing';
import { apodization, } from '../../../apodization/apodization';
import { zeroFilling } from './zeroFilling';
export function fftIndirectDimension(data, options) {
    const newData = {
        re: Matrix.checkMatrix(data.re),
        im: Matrix.checkMatrix(data.im),
    };
    const nbRows = newData.re.rows;
    const nbColumns = newData.re.columns;
    const { zeroFilling: zeroFillingF1, reverse } = options;
    const { factor: f1Factor = 2 } = zeroFillingF1 || {};
    const nbPoints = zeroFillingF1?.nbPoints || 2 ** Math.round(Math.log2(nbRows * f1Factor));
    const { fnMode } = options;
    const newOptions = {
        ...options,
        zeroFilling: { ...zeroFillingF1, nbPoints },
    };
    const quadrants = {};
    if (fnMode === 'QF') {
        const reResult = new Matrix(nbPoints, nbColumns);
        const imResult = new Matrix(nbPoints, nbColumns);
        for (let i = 0; i < nbColumns; i++) {
            const data = {
                re: newData.re.getColumn(i),
                im: reverse
                    ? newData.im.getColumn(i)
                    : xMultiply(newData.im.getColumn(i), -1),
            };
            const { re, im } = applyFFT(data, newOptions);
            reResult.setColumn(i, re);
            imResult.setColumn(i, im);
        }
        quadrants.rr = reResult;
        quadrants.ir = imResult;
    }
    else {
        // four quadrant processing
        for (const current in newData) {
            const reResult = new Matrix(nbPoints, nbColumns);
            const imResult = new Matrix(nbPoints, nbColumns);
            for (let i = 0; i < nbColumns; i++) {
                const data = getColumnFrom(newData[current], { fnMode, index: i });
                const { re, im } = applyFFT(data, newOptions);
                reResult.setColumn(i, re);
                imResult.setColumn(i, im);
            }
            if (current === 're') {
                quadrants.rr = reResult;
                quadrants.ir = imResult;
            }
            else {
                quadrants.ri = reResult;
                quadrants.ii = imResult;
            }
        }
    }
    return quadrants;
}
function applyFFT(data, options) {
    const { fnMode, apodization: apodizationF1, zeroFilling: zeroFillingF1 = {}, phaseCorrection = {}, } = options;
    const { re, im } = apodization(data, apodizationF1);
    const { nbPoints = 0 } = zeroFillingF1;
    const transformed = reimFFT(zeroFilling({ re, im }, { nbPoints }), {
        applyZeroShift: !['SEQ', 'TPPI'].some((k) => fnMode === k),
    });
    if (options.phaseCorrection?.mode === 'mc') {
        Object.assign(transformed, {
            re: reimAbsolute(transformed),
            im: new Float64Array(nbPoints),
        });
    }
    const { mode: pcModeF1, ph0: ph0F1, ph1: ph1F1 } = phaseCorrection;
    if (pcModeF1 === 'pk' && ph0F1 !== undefined && ph1F1 !== undefined) {
        Object.assign(transformed, reimPhaseCorrection(transformed, (ph0F1 * Math.PI) / 180, (ph1F1 * Math.PI) / 180));
    }
    return transformed;
}
function getColumnFrom(data, info) {
    const { fnMode, index } = info;
    const reverse = info.reverse || fnMode === 'QF';
    const nbPoints = data.rows / 2;
    const re = new Float64Array(nbPoints);
    const im = new Float64Array(nbPoints);
    switch (fnMode?.toLocaleLowerCase()) {
        // case 'states':
        // case 'echo-antiecho':
        case 'seq':
        case 'tppi':
            return {
                re: data.getColumn(index),
                im: new Float64Array(data.rows),
            };
        default:
            if (reverse) {
                for (let i = 0; i < nbPoints; i++) {
                    re[i] = data.get(2 * i, index);
                    im[i] = -data.get(2 * i + 1, index);
                }
            }
            else {
                for (let i = 0; i < nbPoints; i++) {
                    re[i] = data.get(2 * i, index);
                    im[i] = data.get(2 * i + 1, index);
                }
            }
    }
    if (fnMode === 'states-ttpi') {
        //it is to convert to the equivalent of states
        for (let i = 0; i < nbPoints; i += 2) {
            re[i] *= -1;
            im[i] *= -1;
        }
    }
    return { re, im };
}
//# sourceMappingURL=fftIndirectDimension.js.map